import { useQuery } from 'react-query';
import { useServices } from '../../../services/useServices';

export const useTitleHistory = (
  source: string,
  identifier: { amazonasin?: string; fiction_id?: string; author_id?: string },
  enabled: boolean
) => {
  const {
    book: { getTitleHistory }
  } = useServices();

  const res = useQuery(
    ['get-title-history', source, identifier.amazonasin ?? identifier.fiction_id ?? identifier.author_id],
    () => getTitleHistory(source, identifier),
    {
      enabled: enabled && Boolean(identifier.amazonasin ?? identifier.fiction_id ?? identifier.author_id)
    }
  );

  return {
    data: res.data,
    isError: res.isError,
    isLoading: res.isLoading
  };
};